module.exports = __webpack_public_path__ + "img/sancionar.109a0aee.png";